import React from "react";
import request from "src/utils/request";
import useDashboardApi from "src/scenes/dashboard/hooks/use-dashboard-api";
import overviewTimeseriesMockData from "src/scenes/overview/overview-components/overview-timeseries-mock-data";
import overviewMockData from "src/scenes/overview/overview-components/overview-mock-data";

const useExecutiveApi = ({
    selectedTeam,
    setExpandedView,
    type,
    refresh,
    aggregationPeriod,
    semesters,
    devsOnly,
}) => {
    const requestUrl =
        type === "overview"
            ? `/api/data/executive-summary`
            : `/api/data/executive-summary-timeseries`;
    const Timemock = overviewTimeseriesMockData({ aggregationPeriod });
    const mockData = type === "overview" ? overviewMockData : Timemock;

    const [options, setOptions] = React.useState({
        method: "POST",
        body: JSON.stringify({
            users: `integrated${devsOnly ? `-developers` : ""}`,
            teamId: undefined,
            refresh,
            ...(type !== "overview" && { aggregationPeriod }),
            ...(semesters && { semesters }),
        }),
    });

    React.useEffect(() => {
        if (selectedTeam) {
            if (selectedTeam === "integrated") {
                setOptions({
                    method: "POST",
                    body: JSON.stringify({
                        users: `integrated${devsOnly ? `-developers` : ""}`,
                        teamId: undefined,
                        refresh,
                        ...(type !== "overview" && { aggregationPeriod }),
                        ...(semesters && { semesters }),
                    }),
                });
            } else if (selectedTeam === "all") {
                setOptions({
                    method: "POST",
                    body: JSON.stringify({
                        users: `all${devsOnly ? `-developers` : ""}`,
                        teamId: undefined,
                        refresh,
                        ...(type !== "overview" && { aggregationPeriod }),
                        ...(semesters && { semesters }),
                    }),
                });
            } else {
                setOptions({
                    method: "POST",
                    body: JSON.stringify({
                        users: `team${devsOnly ? `-developers` : ""}`,
                        teamId: selectedTeam,
                        refresh,
                        ...(type !== "overview" && { aggregationPeriod }),
                        ...(semesters && { semesters }),
                    }),
                });
            }
            setExpandedView(false);
        }
    }, [selectedTeam, refresh, aggregationPeriod, devsOnly, semesters]);

    const requestHandler = (abortController) => {
        return request(requestUrl, {
            ...options,
            signal: abortController.signal,
        });
    };

    return useDashboardApi(
        () => mockData,
        ({ abortController }) => requestHandler(abortController),
        undefined,
        requestUrl,
        options
    );
};

export default useExecutiveApi;
